exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumbs_wrap{height:32px;width:100%;padding:0;background-color:#999;padding-top:7.5px;padding-left:24px}.breadcrumbs{text-align:left;overflow:visible;position:relative;margin:auto;max-width:1024px;font-weight:600;color:#ececec}.breadcrumbs i{position:relative;top:-2px!important}.breadcrumbs i.element-icon{font-size:14px;top:-7.5px!important}.breadcrumbs a{position:relative;color:inherit;text-decoration:inherit;font-weight:700;top:-9px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3fa1547c!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Breadcrumbs.vue
// module id = 222
// module chunks = 0